import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateMoneyPageAutomation as UpdateMoneyPageAutomationMutation,
    UpdateMoneyPageAutomationVariables,
    UrlAutomationUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_MONEY_PAGE_AUTOMATION from '../mutations/update-money-page-automation.graphql';

export const useUpdateMoneyPageAutomation = (): {
    updateMoneyPageAutomation: (input: UrlAutomationUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateMoneyPageAutomation, {loading, error}] = useMutation<
        UpdateMoneyPageAutomationMutation,
        UpdateMoneyPageAutomationVariables
    >(UPDATE_MONEY_PAGE_AUTOMATION);

    return {
        updateMoneyPageAutomation: (input: UrlAutomationUpdateInput) =>
            updateMoneyPageAutomation({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
